// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__35F1G","label":"Category_label__2gT1q","content":"Category_content__2vgJ0","header":"Category_header__3iVWw","location":"Category_location__3UIY4"};